<s1-input-select [control]="control" [itemsList]="ruoli" [label]="label"></s1-input-select>